import { MetricCardsGrid, MetricCard } from "@/components/common/MetricCards";
import { Reimbursement } from "@/types";
import { formatUSD } from "@/utils/formatters/currencyFormatter";
import { formatShortDate } from "@/utils/formatters/dateFormatter";
import { useRecordContext } from "react-admin";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PaymentIcon from "@mui/icons-material/Payment";
export const ReimbursementMetrics = () => {
  const record = useRecordContext<Reimbursement>();
  if (!record) return null;

  const requested = record.requested_amount || 0;
  const reimbursed = record.reimbursement_amount || 0;
  const pended = record.pended_amount || 0;
  const adjusted = record.adjustment_amount || 0;
  const denied = record.denial_amount || 0;

  const paymentMethod = record.eft ? "EFT" : record.check_number ? `Check #${record.check_number}` : "—";

  return (
    <MetricCardsGrid columns={3}>
      <MetricCard
        icon={<AttachMoneyIcon sx={{ fontSize: 18, color: "primary.main" }} />}
        title="Amount Requested"
        value={formatUSD(requested)}
        subMetrics={[
          { label: "Reimbursed", value: formatUSD(reimbursed) },
          { label: "Pended", value: formatUSD(pended) },
          ...(adjusted > 0 ? [{ label: "Adjusted", value: formatUSD(adjusted) }] : []),
          ...(denied > 0 ? [{ label: "Denied", value: formatUSD(denied), color: "error.main" }] : []),
        ]}
      />
      <MetricCard
        icon={<CalendarTodayIcon sx={{ fontSize: 18, color: "primary.main" }} />}
        title="Service Period"
        value={
          record.service_start_date && record.service_end_date
            ? `${formatShortDate(record.service_start_date)} - ${formatShortDate(record.service_end_date)}`
            : record.service_start_date
              ? formatShortDate(record.service_start_date)
              : "—"
        }
        subMetrics={[
          { label: "Received", value: record.received_date ? formatShortDate(record.received_date) : "—" },
          { label: "Check Date", value: record.check_date ? formatShortDate(record.check_date) : "—" },
        ]}
      />
      <MetricCard
        icon={<PaymentIcon sx={{ fontSize: 18, color: "primary.main" }} />}
        title="Payment"
        value={paymentMethod}
        subMetrics={[
          // The date the Claims Summary reports this reimbursement under (#7560).
          { label: "Payment Date", value: record.payment_date ? formatShortDate(record.payment_date) : "—" },
          ...(record.check_number ? [{ label: "Check #", value: record.check_number }] : []),
          { label: "EFT", value: record.eft ? "Yes" : "No" },
        ]}
      />
    </MetricCardsGrid>
  );
};
